export class NgxSpinnerConfiguration {
  bdColor: string;
  color: string;
  size: string;
  type: string;
}
